export const response = {
  "product": {
    "id": 14904810733935,
    "title": "ME3D Personalized Insoles",
    "body_html": "<p><meta charset=\"utf-8\">3D Printed Insoles Made for You<br></p>",
    "vendor": "Superfeet",
    "product_type": "Insole",
    "created_at": "2026-03-04T19:09:11-05:00",
    "handle": "superrev-me3d",
    "updated_at": "2026-08-05T12:44:31-04:00",
    "published_at": "2026-06-02T21:16:53-04:00",
    "template_suffix": "personalized",
    "published_scope": "web",
    "tags": "ALL INSOLES, exclude-from-feed, INSOLES, KIDS, MEN'S, PERSONALIZED, RUNNING, SHOP, UNISEX, WOMEN'S",
    "variants": [
      {
        "id": 52725369340271,
        "product_id": 14904810733935,
        "title": "SuperRev™ / Men’s 5 / Women’s 6",
        "price": "109.99",
        "sku": "FL777005",
        "position": 1,
        "compare_at_price": "",
        "fulfillment_service": "manual",
        "inventory_management": null,
        "option1": "SuperRev™",
        "option2": "Men’s 5 / Women’s 6",
        "option3": null,
        "created_at": "2026-03-04T19:10:14-05:00",
        "updated_at": "2026-08-05T12:44:31-04:00",
        "taxable": true,
        "barcode": "086301823548",
        "grams": 0,
        "image_id": null,
        "weight": 0,
        "weight_unit": "lb",
        "requires_shipping": true,
        "quantity_rule": {
          "min": 1,
          "max": null,
          "increment": 1
        },
        "price_currency": "USD",
        "compare_at_price_currency": "",
        "quantity_price_breaks": []
      },
      {
        "id": 52763782513007,
        "product_id": 14904810733935,
        "title": "SuperRev™ / Men’s 6 / Women’s 7",
        "price": "109.99",
        "sku": "FL777006",
        "position": 2,
        "compare_at_price": "",
        "fulfillment_service": "manual",
        "inventory_management": null,
        "option1": "SuperRev™",
        "option2": "Men’s 6 / Women’s 7",
        "option3": null,
        "created_at": "2026-03-17T14:49:06-04:00",
        "updated_at": "2026-08-05T12:44:31-04:00",
        "taxable": true,
        "barcode": null,
        "grams": 0,
        "image_id": null,
        "weight": 0,
        "weight_unit": "lb",
        "requires_shipping": true,
        "quantity_rule": {
          "min": 1,
          "max": null,
          "increment": 1
        },
        "price_currency": "USD",
        "compare_at_price_currency": "",
        "quantity_price_breaks": []
      },
      {
        "id": 52763782545775,
        "product_id": 14904810733935,
        "title": "SuperRev™ / Men’s 7 / Women’s 8",
        "price": "109.99",
        "sku": "FL777007",
        "position": 3,
        "compare_at_price": "",
        "fulfillment_service": "manual",
        "inventory_management": null,
        "option1": "SuperRev™",
        "option2": "Men’s 7 / Women’s 8",
        "option3": null,
        "created_at": "2026-03-17T14:49:06-04:00",
        "updated_at": "2026-08-05T12:44:31-04:00",
        "taxable": true,
        "barcode": null,
        "grams": 0,
        "image_id": null,
        "weight": 0,
        "weight_unit": "lb",
        "requires_shipping": true,
        "quantity_rule": {
          "min": 1,
          "max": null,
          "increment": 1
        },
        "price_currency": "USD",
        "compare_at_price_currency": "",
        "quantity_price_breaks": []
      },
      {
        "id": 52763782578543,
        "product_id": 14904810733935,
        "title": "SuperRev™ / Men’s 8 / Women’s 9",
        "price": "109.99",
        "sku": "FL777008",
        "position": 4,
        "compare_at_price": "",
        "fulfillment_service": "manual",
        "inventory_management": null,
        "option1": "SuperRev™",
        "option2": "Men’s 8 / Women’s 9",
        "option3": null,
        "created_at": "2026-03-17T14:49:06-04:00",
        "updated_at": "2026-08-05T12:44:31-04:00",
        "taxable": true,
        "barcode": null,
        "grams": 0,
        "image_id": null,
        "weight": 0,
        "weight_unit": "lb",
        "requires_shipping": true,
        "quantity_rule": {
          "min": 1,
          "max": null,
          "increment": 1
        },
        "price_currency": "USD",
        "compare_at_price_currency": "",
        "quantity_price_breaks": []
      },
      {
        "id": 52763782611311,
        "product_id": 14904810733935,
        "title": "SuperRev™ / Men’s 9 / Women’s 10",
        "price": "109.99",
        "sku": "FL777009",
        "position": 5,
        "compare_at_price": "",
        "fulfillment_service": "manual",
        "inventory_management": null,
        "option1": "SuperRev™",
        "option2": "Men’s 9 / Women’s 10",
        "option3": null,
        "created_at": "2026-03-17T14:49:06-04:00",
        "updated_at": "2026-08-05T12:44:31-04:00",
        "taxable": true,
        "barcode": null,
        "grams": 0,
        "image_id": null,
        "weight": 0,
        "weight_unit": "lb",
        "requires_shipping": true,
        "quantity_rule": {
          "min": 1,
          "max": null,
          "increment": 1
        },
        "price_currency": "USD",
        "compare_at_price_currency": "",
        "quantity_price_breaks": []
      },
      {
        "id": 52763782644079,
        "product_id": 14904810733935,
        "title": "SuperRev™ / Men’s 10 / Women’s 11",
        "price": "109.99",
        "sku": "FL777010",
        "position": 6,
        "compare_at_price": "",
        "fulfillment_service": "manual",
        "inventory_management": null,
        "option1": "SuperRev™",
        "option2": "Men’s 10 / Women’s 11",
        "option3": null,
        "created_at": "2026-03-17T14:49:06-04:00",
        "updated_at": "2026-08-05T12:44:31-04:00",
        "taxable": true,
        "barcode": null,
        "grams": 0,
        "image_id": null,
        "weight": 0,
        "weight_unit": "lb",
        "requires_shipping": true,
        "quantity_rule": {
          "min": 1,
          "max": null,
          "increment": 1
        },
        "price_currency": "USD",
        "compare_at_price_currency": "",
        "quantity_price_breaks": []
      },
      {
        "id": 52763782676847,
        "product_id": 14904810733935,
        "title": "SuperRev™ / Men’s 11 / Women’s 12",
        "price": "109.99",
        "sku": "FL777011",
        "position": 7,
        "compare_at_price": "",
        "fulfillment_service": "manual",
        "inventory_management": null,
        "option1": "SuperRev™",
        "option2": "Men’s 11 / Women’s 12",
        "option3": null,
        "created_at": "2026-03-17T14:49:06-04:00",
        "updated_at": "2026-08-05T12:44:31-04:00",
        "taxable": true,
        "barcode": null,
        "grams": 0,
        "image_id": null,
        "weight": 0,
        "weight_unit": "lb",
        "requires_shipping": true,
        "quantity_rule": {
          "min": 1,
          "max": null,
          "increment": 1
        },
        "price_currency": "USD",
        "compare_at_price_currency": "",
        "quantity_price_breaks": []
      },
      {
        "id": 52763782709615,
        "product_id": 14904810733935,
        "title": "SuperRev™ / Men’s 12 / Women’s 13",
        "price": "109.99",
        "sku": "FL777012",
        "position": 8,
        "compare_at_price": "",
        "fulfillment_service": "manual",
        "inventory_management": null,
        "option1": "SuperRev™",
        "option2": "Men’s 12 / Women’s 13",
        "option3": null,
        "created_at": "2026-03-17T14:49:06-04:00",
        "updated_at": "2026-08-05T12:44:31-04:00",
        "taxable": true,
        "barcode": null,
        "grams": 0,
        "image_id": null,
        "weight": 0,
        "weight_unit": "lb",
        "requires_shipping": true,
        "quantity_rule": {
          "min": 1,
          "max": null,
          "increment": 1
        },
        "price_currency": "USD",
        "compare_at_price_currency": "",
        "quantity_price_breaks": []
      },
      {
        "id": 52763782742383,
        "product_id": 14904810733935,
        "title": "SuperRev™ / Men’s 13 / Women’s 14",
        "price": "109.99",
        "sku": "FL777013",
        "position": 9,
        "compare_at_price": "",
        "fulfillment_service": "manual",
        "inventory_management": null,
        "option1": "SuperRev™",
        "option2": "Men’s 13 / Women’s 14",
        "option3": null,
        "created_at": "2026-03-17T14:49:06-04:00",
        "updated_at": "2026-08-05T12:44:31-04:00",
        "taxable": true,
        "barcode": null,
        "grams": 0,
        "image_id": null,
        "weight": 0,
        "weight_unit": "lb",
        "requires_shipping": true,
        "quantity_rule": {
          "min": 1,
          "max": null,
          "increment": 1
        },
        "price_currency": "USD",
        "compare_at_price_currency": "",
        "quantity_price_breaks": []
      },
      {
        "id": 52763782775151,
        "product_id": 14904810733935,
        "title": "SuperRev™ / Men’s 14 / Women’s 15",
        "price": "109.99",
        "sku": "FL777014",
        "position": 10,
        "compare_at_price": "",
        "fulfillment_service": "manual",
        "inventory_management": null,
        "option1": "SuperRev™",
        "option2": "Men’s 14 / Women’s 15",
        "option3": null,
        "created_at": "2026-03-17T14:49:06-04:00",
        "updated_at": "2026-08-05T12:44:31-04:00",
        "taxable": true,
        "barcode": null,
        "grams": 0,
        "image_id": null,
        "weight": 0,
        "weight_unit": "lb",
        "requires_shipping": true,
        "quantity_rule": {
          "min": 1,
          "max": null,
          "increment": 1
        },
        "price_currency": "USD",
        "compare_at_price_currency": "",
        "quantity_price_breaks": []
      },
      {
        "id": 52763782807919,
        "product_id": 14904810733935,
        "title": "SuperRev™ / Men’s 15 / Women’s 16",
        "price": "109.99",
        "sku": "FL777015",
        "position": 11,
        "compare_at_price": "",
        "fulfillment_service": "manual",
        "inventory_management": null,
        "option1": "SuperRev™",
        "option2": "Men’s 15 / Women’s 16",
        "option3": null,
        "created_at": "2026-03-17T14:49:06-04:00",
        "updated_at": "2026-08-05T12:44:31-04:00",
        "taxable": true,
        "barcode": null,
        "grams": 0,
        "image_id": null,
        "weight": 0,
        "weight_unit": "lb",
        "requires_shipping": true,
        "quantity_rule": {
          "min": 1,
          "max": null,
          "increment": 1
        },
        "price_currency": "USD",
        "compare_at_price_currency": "",
        "quantity_price_breaks": []
      },
      {
        "id": 52725370028399,
        "product_id": 14904810733935,
        "title": "SuperRev™ Max / Men’s 5 / Women’s 6",
        "price": "139.99",
        "sku": "FL778505",
        "position": 12,
        "compare_at_price": "",
        "fulfillment_service": "manual",
        "inventory_management": null,
        "option1": "SuperRev™ Max",
        "option2": "Men’s 5 / Women’s 6",
        "option3": null,
        "created_at": "2026-03-04T19:12:03-05:00",
        "updated_at": "2026-08-05T12:44:31-04:00",
        "taxable": true,
        "barcode": null,
        "grams": 0,
        "image_id": null,
        "weight": 0,
        "weight_unit": "lb",
        "requires_shipping": true,
        "quantity_rule": {
          "min": 1,
          "max": null,
          "increment": 1
        },
        "price_currency": "USD",
        "compare_at_price_currency": "",
        "quantity_price_breaks": []
      },
      {
        "id": 52763782840687,
        "product_id": 14904810733935,
        "title": "SuperRev™ Max / Men’s 6 / Women’s 7",
        "price": "139.99",
        "sku": "FL778506",
        "position": 13,
        "compare_at_price": "",
        "fulfillment_service": "manual",
        "inventory_management": null,
        "option1": "SuperRev™ Max",
        "option2": "Men’s 6 / Women’s 7",
        "option3": null,
        "created_at": "2026-03-17T14:49:06-04:00",
        "updated_at": "2026-08-05T12:44:31-04:00",
        "taxable": true,
        "barcode": null,
        "grams": 0,
        "image_id": null,
        "weight": 0,
        "weight_unit": "lb",
        "requires_shipping": true,
        "quantity_rule": {
          "min": 1,
          "max": null,
          "increment": 1
        },
        "price_currency": "USD",
        "compare_at_price_currency": "",
        "quantity_price_breaks": []
      },
      {
        "id": 52763782873455,
        "product_id": 14904810733935,
        "title": "SuperRev™ Max / Men’s 7 / Women’s 8",
        "price": "139.99",
        "sku": "FL778507",
        "position": 14,
        "compare_at_price": "",
        "fulfillment_service": "manual",
        "inventory_management": null,
        "option1": "SuperRev™ Max",
        "option2": "Men’s 7 / Women’s 8",
        "option3": null,
        "created_at": "2026-03-17T14:49:06-04:00",
        "updated_at": "2026-08-05T12:44:31-04:00",
        "taxable": true,
        "barcode": null,
        "grams": 0,
        "image_id": null,
        "weight": 0,
        "weight_unit": "lb",
        "requires_shipping": true,
        "quantity_rule": {
          "min": 1,
          "max": null,
          "increment": 1
        },
        "price_currency": "USD",
        "compare_at_price_currency": "",
        "quantity_price_breaks": []
      },
      {
        "id": 52763782906223,
        "product_id": 14904810733935,
        "title": "SuperRev™ Max / Men’s 8 / Women’s 9",
        "price": "139.99",
        "sku": "FL778508",
        "position": 15,
        "compare_at_price": "",
        "fulfillment_service": "manual",
        "inventory_management": null,
        "option1": "SuperRev™ Max",
        "option2": "Men’s 8 / Women’s 9",
        "option3": null,
        "created_at": "2026-03-17T14:49:06-04:00",
        "updated_at": "2026-08-05T12:44:31-04:00",
        "taxable": true,
        "barcode": null,
        "grams": 0,
        "image_id": null,
        "weight": 0,
        "weight_unit": "lb",
        "requires_shipping": true,
        "quantity_rule": {
          "min": 1,
          "max": null,
          "increment": 1
        },
        "price_currency": "USD",
        "compare_at_price_currency": "",
        "quantity_price_breaks": []
      },
      {
        "id": 52763782938991,
        "product_id": 14904810733935,
        "title": "SuperRev™ Max / Men’s 9 / Women’s 10",
        "price": "139.99",
        "sku": "FL778509",
        "position": 16,
        "compare_at_price": "",
        "fulfillment_service": "manual",
        "inventory_management": null,
        "option1": "SuperRev™ Max",
        "option2": "Men’s 9 / Women’s 10",
        "option3": null,
        "created_at": "2026-03-17T14:49:06-04:00",
        "updated_at": "2026-08-05T12:44:31-04:00",
        "taxable": true,
        "barcode": null,
        "grams": 0,
        "image_id": null,
        "weight": 0,
        "weight_unit": "lb",
        "requires_shipping": true,
        "quantity_rule": {
          "min": 1,
          "max": null,
          "increment": 1
        },
        "price_currency": "USD",
        "compare_at_price_currency": "",
        "quantity_price_breaks": []
      },
      {
        "id": 52763782971759,
        "product_id": 14904810733935,
        "title": "SuperRev™ Max / Men’s 10 / Women’s 11",
        "price": "139.99",
        "sku": "FL778510",
        "position": 17,
        "compare_at_price": "",
        "fulfillment_service": "manual",
        "inventory_management": null,
        "option1": "SuperRev™ Max",
        "option2": "Men’s 10 / Women’s 11",
        "option3": null,
        "created_at": "2026-03-17T14:49:06-04:00",
        "updated_at": "2026-08-05T12:44:31-04:00",
        "taxable": true,
        "barcode": null,
        "grams": 0,
        "image_id": null,
        "weight": 0,
        "weight_unit": "lb",
        "requires_shipping": true,
        "quantity_rule": {
          "min": 1,
          "max": null,
          "increment": 1
        },
        "price_currency": "USD",
        "compare_at_price_currency": "",
        "quantity_price_breaks": []
      },
      {
        "id": 52763783004527,
        "product_id": 14904810733935,
        "title": "SuperRev™ Max / Men’s 11 / Women’s 12",
        "price": "139.99",
        "sku": "FL778511",
        "position": 18,
        "compare_at_price": "",
        "fulfillment_service": "manual",
        "inventory_management": null,
        "option1": "SuperRev™ Max",
        "option2": "Men’s 11 / Women’s 12",
        "option3": null,
        "created_at": "2026-03-17T14:49:06-04:00",
        "updated_at": "2026-08-05T12:44:31-04:00",
        "taxable": true,
        "barcode": null,
        "grams": 0,
        "image_id": null,
        "weight": 0,
        "weight_unit": "lb",
        "requires_shipping": true,
        "quantity_rule": {
          "min": 1,
          "max": null,
          "increment": 1
        },
        "price_currency": "USD",
        "compare_at_price_currency": "",
        "quantity_price_breaks": []
      },
      {
        "id": 52763783037295,
        "product_id": 14904810733935,
        "title": "SuperRev™ Max / Men’s 12 / Women’s 13",
        "price": "139.99",
        "sku": "FL778512",
        "position": 19,
        "compare_at_price": "",
        "fulfillment_service": "manual",
        "inventory_management": null,
        "option1": "SuperRev™ Max",
        "option2": "Men’s 12 / Women’s 13",
        "option3": null,
        "created_at": "2026-03-17T14:49:06-04:00",
        "updated_at": "2026-08-05T12:44:31-04:00",
        "taxable": true,
        "barcode": null,
        "grams": 0,
        "image_id": null,
        "weight": 0,
        "weight_unit": "lb",
        "requires_shipping": true,
        "quantity_rule": {
          "min": 1,
          "max": null,
          "increment": 1
        },
        "price_currency": "USD",
        "compare_at_price_currency": "",
        "quantity_price_breaks": []
      },
      {
        "id": 52763783070063,
        "product_id": 14904810733935,
        "title": "SuperRev™ Max / Men’s 13 / Women’s 14",
        "price": "139.99",
        "sku": "FL778513",
        "position": 20,
        "compare_at_price": "",
        "fulfillment_service": "manual",
        "inventory_management": null,
        "option1": "SuperRev™ Max",
        "option2": "Men’s 13 / Women’s 14",
        "option3": null,
        "created_at": "2026-03-17T14:49:06-04:00",
        "updated_at": "2026-08-05T12:44:31-04:00",
        "taxable": true,
        "barcode": null,
        "grams": 0,
        "image_id": null,
        "weight": 0,
        "weight_unit": "lb",
        "requires_shipping": true,
        "quantity_rule": {
          "min": 1,
          "max": null,
          "increment": 1
        },
        "price_currency": "USD",
        "compare_at_price_currency": "",
        "quantity_price_breaks": []
      },
      {
        "id": 52763783102831,
        "product_id": 14904810733935,
        "title": "SuperRev™ Max / Men’s 14 / Women’s 15",
        "price": "139.99",
        "sku": "FL778514",
        "position": 21,
        "compare_at_price": "",
        "fulfillment_service": "manual",
        "inventory_management": null,
        "option1": "SuperRev™ Max",
        "option2": "Men’s 14 / Women’s 15",
        "option3": null,
        "created_at": "2026-03-17T14:49:06-04:00",
        "updated_at": "2026-08-05T12:44:31-04:00",
        "taxable": true,
        "barcode": null,
        "grams": 0,
        "image_id": null,
        "weight": 0,
        "weight_unit": "lb",
        "requires_shipping": true,
        "quantity_rule": {
          "min": 1,
          "max": null,
          "increment": 1
        },
        "price_currency": "USD",
        "compare_at_price_currency": "",
        "quantity_price_breaks": []
      },
      {
        "id": 52763783135599,
        "product_id": 14904810733935,
        "title": "SuperRev™ Max / Men’s 15 / Women’s 16",
        "price": "139.99",
        "sku": "FL778515",
        "position": 22,
        "compare_at_price": "",
        "fulfillment_service": "manual",
        "inventory_management": null,
        "option1": "SuperRev™ Max",
        "option2": "Men’s 15 / Women’s 16",
        "option3": null,
        "created_at": "2026-03-17T14:49:06-04:00",
        "updated_at": "2026-08-05T12:44:31-04:00",
        "taxable": true,
        "barcode": null,
        "grams": 0,
        "image_id": null,
        "weight": 0,
        "weight_unit": "lb",
        "requires_shipping": true,
        "quantity_rule": {
          "min": 1,
          "max": null,
          "increment": 1
        },
        "price_currency": "USD",
        "compare_at_price_currency": "",
        "quantity_price_breaks": []
      }
    ],
    "options": [
      {
        "id": 17286922109295,
        "product_id": 14904810733935,
        "name": "Foam Package",
        "position": 1,
        "values": [
          "SuperRev™",
          "SuperRev™ Max"
        ]
      },
      {
        "id": 17297662476655,
        "product_id": 14904810733935,
        "name": "Size",
        "position": 2,
        "values": [
          "Men’s 5 / Women’s 6",
          "Men’s 6 / Women’s 7",
          "Men’s 7 / Women’s 8",
          "Men’s 8 / Women’s 9",
          "Men’s 9 / Women’s 10",
          "Men’s 10 / Women’s 11",
          "Men’s 11 / Women’s 12",
          "Men’s 12 / Women’s 13",
          "Men’s 13 / Women’s 14",
          "Men’s 14 / Women’s 15",
          "Men’s 15 / Women’s 16"
        ]
      }
    ],
    "images": [
      {
        "id": 62410172399983,
        "product_id": 14904810733935,
        "position": 1,
        "created_at": "2026-05-04T16:53:52-04:00",
        "updated_at": "2026-05-04T16:53:54-04:00",
        "alt": "Person holding a white sneaker while putting in Superfeet's ME3D Personalized Insole. ",
        "width": 3200,
        "height": 1400,
        "src": "https://cdn.shopify.com/s/files/1/0638/5346/1687/files/ME3D_Default_Image_1.webp?v=1777928034",
        "variant_ids": []
      },
      {
        "id": 62410172465519,
        "product_id": 14904810733935,
        "position": 2,
        "created_at": "2026-05-04T16:53:52-04:00",
        "updated_at": "2026-05-04T16:53:54-04:00",
        "alt": "Close-up of Superfeet's SuperRev foam. ",
        "width": 3200,
        "height": 1400,
        "src": "https://cdn.shopify.com/s/files/1/0638/5346/1687/files/ME3D_Default_Image_2.webp?v=1777928034",
        "variant_ids": []
      },
      {
        "id": 62410172432751,
        "product_id": 14904810733935,
        "position": 3,
        "created_at": "2026-05-04T16:53:52-04:00",
        "updated_at": "2026-05-04T16:53:54-04:00",
        "alt": "Close-up of Superfeet's SuperRev Max foam. ",
        "width": 3200,
        "height": 1400,
        "src": "https://cdn.shopify.com/s/files/1/0638/5346/1687/files/ME3D_Default_Image_3.webp?v=1777928034",
        "variant_ids": []
      },
      {
        "id": 62410172367215,
        "product_id": 14904810733935,
        "position": 4,
        "created_at": "2026-05-04T16:53:52-04:00",
        "updated_at": "2026-05-04T16:53:53-04:00",
        "alt": "Person holding a Superfeet's SuperRev Max Personalized Insole.",
        "width": 3200,
        "height": 1400,
        "src": "https://cdn.shopify.com/s/files/1/0638/5346/1687/files/ME3D_Default_Image_4.webp?v=1777928033",
        "variant_ids": []
      },
      {
        "id": 62410172301679,
        "product_id": 14904810733935,
        "position": 5,
        "created_at": "2026-05-04T16:53:52-04:00",
        "updated_at": "2026-05-04T16:53:54-04:00",
        "alt": null,
        "width": 3200,
        "height": 1400,
        "src": "https://cdn.shopify.com/s/files/1/0638/5346/1687/files/ME3D_Default_Image_5.webp?v=1777928034",
        "variant_ids": []
      },
      {
        "id": 62410172334447,
        "product_id": 14904810733935,
        "position": 6,
        "created_at": "2026-05-04T16:53:52-04:00",
        "updated_at": "2026-05-04T16:53:53-04:00",
        "alt": null,
        "width": 3200,
        "height": 1400,
        "src": "https://cdn.shopify.com/s/files/1/0638/5346/1687/files/ME3D_Default_Image_6.webp?v=1777928033",
        "variant_ids": []
      }
    ],
    "image": {
      "id": 62410172399983,
      "product_id": 14904810733935,
      "position": 1,
      "created_at": "2026-05-04T16:53:52-04:00",
      "updated_at": "2026-05-04T16:53:54-04:00",
      "alt": "Person holding a white sneaker while putting in Superfeet's ME3D Personalized Insole. ",
      "width": 3200,
      "height": 1400,
      "src": "https://cdn.shopify.com/s/files/1/0638/5346/1687/files/ME3D_Default_Image_1.webp?v=1777928034",
      "variant_ids": []
    }
  }
};
